import React, { Fragment, useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { Loader } from "../components/Loader";
import { dateHelperService } from "../services/date-helper.service";
import { FORM_LIST_HEADERS, FORM_CATEGORIES } from "../services/form.helper.service";
import { FORM_STATUS, previousVersionResponseState, dialogState, FormStore } from "../services/form.store";
import { language } from "../services/form-list.service";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CopyFormDialog from "./CopyFormDialog";
import FormListActions from "../shared/component/FormListActions";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minHeight: "95%",
    minWidth: "80%",
    padding: "6px",
  },
  tableHeading: {
    fontWeight: "600",
    fontSize: "15px",
  },
  dialogTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  emptyState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh",
  },
}));

const getCategory = (form, name) => {
  let filtered = form.formCategories.filter(
    (formCategory) => formCategory.categoryType === name,
  );
  if (filtered.length) return filtered[0].categoryName;
  else return "NA";
};

export default function PreviousVersionDialog(props) {
  const { open, onClose, previousFormDataLoading } = props;
  const classes = useStyles();
  const [versions, setVersions] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedForm, setSelectedForm] = useState(null);
  const [showCopyDialog, setShowCopyDialog] = useState(false);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (open) {
      setVersions([]);
      setIsLoading(true);
    }
  }, [open]);

  useEffect(() => {
    dialogState.subscribe((val) => {
      setShowCopyDialog(false);
    });
  }, []);


  useEffect(() => {
    const languageSubscription = language.subscribe((langs) => {
      if (langs?.length) setLanguageList(langs);
    });
    return () => languageSubscription.unsubscribe();
  }, []);

  useEffect(() => {
    // console.log("previousFormDataLoading before ==> ", previousFormDataLoading);
    const subscription = previousVersionResponseState.subscribe((res) => {
      setIsLoading(previousFormDataLoading);
      if (res?.data) {
        setVersions(res.data);
        // console.log("previous versions data ==> ", JSON.stringify(res.data));
        setIsLoading(false);
      } else {
        setVersions([]);
      }
    });
    // console.log("previousFormDataLoading after ==> ", previousFormDataLoading);
    return () => subscription.unsubscribe();
  }, [])

  // const headers = FORM_LIST_HEADERS.filter(h => h.id !== 'subGroup');
  const headers = FORM_LIST_HEADERS;

  const getLanguageName = (code) => {
    const found = languageList.find(
      (lang) => lang.id === code || lang.languageCode === code
    );
    return found ? found.name : code;
  };

  const toggleActionMenu = () => {
    setCopyOpen((prevOpen) => !prevOpen);
  };

  const onClosePopup = () => {
    setTimeout(() => {
      setCopyOpen(false);
    }, 5000);
  };

  const handleMoreClick = (e, item) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    toggleActionMenu();
    setSelectedForm(item);
  };

  const handleClosecopyMenu = () => {
    toggleActionMenu();
  };

  const handleCopy = () => {
    toggleActionMenu();
    if (selectedForm !== undefined) {
      setFormDataLoading(true);
      FormStore.sharedInstance()
        .copyForm(selectedForm?.id)
        .catch((error) => console.error("Failed to copy form :", error))
        .finally(() => setFormDataLoading(false));
      toggleCopyFormDialog();
    }
  };


  const handleCopyCancel = () => {
    toggleCopyFormDialog();
  };

  const toggleCopyFormDialog = () => {
    setShowCopyDialog((prevCopyDialog) => !prevCopyDialog);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="previous-versions-dialog-title"
        aria-describedby="previous-versions-dialog-description"
        classes={{ paper: classes.dialogPaper }}
        fullWidth
        maxWidth="lg"
      >
        <div className={classes.dialogTitleContainer}>
          <DialogTitle id="previous-versions-dialog-title">
            Previous Versions
          </DialogTitle>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>

        {isLoading ? (
          <Loader position="center" loading={isLoading} />
        ) : (
          <Fragment>
            {versions.length > 0 ? (
              <Fragment>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {headers.map((header) => (
                          <TableCell
                            key={header.id}
                            className={classes.tableHeading}
                          >
                            {header.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {versions.map((item, index) => (
                        <TableRow
                          hover
                          onClick={() => history.push("/editForm/" + item.id)}
                          key={index}
                        // hover key={index}
                        >
                          <TableCell component="th" scope="row">
                            <Typography component="div">{item.title}</Typography>
                          </TableCell>
                          <TableCell>{getLanguageName(item.defaultLanguageCode)}</TableCell>
                          <TableCell>
                            {item.formStatus === FORM_STATUS.PUBLISHED
                              ? item.publishedVersion
                              : item.version}
                          </TableCell>
                          <TableCell>{item.formStatus}</TableCell>
                          <TableCell>{item.createdBy}</TableCell>
                          <TableCell>
                            {dateHelperService.formattedDateFromUTS(
                              item.lastUpdatedDate
                            )}
                          </TableCell>
                          <TableCell>
                            {getCategory(item, FORM_CATEGORIES.BUSINESS)}
                          </TableCell>
                          <TableCell>
                            {getCategory(item, FORM_CATEGORIES.SUB_BUSINESS)}
                          </TableCell>
                          <TableCell>
                            {getCategory(item, FORM_CATEGORIES.GROUP)}
                          </TableCell>
                          <TableCell>
                            {getCategory(item, FORM_CATEGORIES.SUB_GROUP)}
                            <IconButton
                              id="copyActions"
                              edge="end"
                              aria-label="more"
                              aria-controls="long-menu"
                              aria-haspopup="true"
                              onClick={(event) => handleMoreClick(event, item)}
                              onMouseLeave={onClosePopup}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <FormListActions
                    open={copyOpen}
                    anchorEl={anchorEl}
                    selectedForm={selectedForm}
                    handleActionCancel={handleClosecopyMenu}
                    handleCopy={handleCopy}
                  ></FormListActions>
                  {
                    showCopyDialog && (
                      <CopyFormDialog
                        open={showCopyDialog}
                        onClose={handleCopyCancel}
                        formDataLoading={formDataLoading}
                      />
                    )
                  }
                </TableContainer>
              </Fragment>
            ) : (
              <div className={classes.emptyState}>
                <Typography variant="h6">No previous versions found.</Typography>
              </div>
            )}
          </Fragment>
        )}

      </Dialog>
    </div>
  );
}